// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-core-navigation_inline {
  flex: 1 1 100%;
  overflow: hidden;
  display: flex;
}
.dl-core-navigation_inline .dl-core-navigation__entries {
  padding-top: 16px;
}
.dl-core-navigation_inline .dl-core-navigation__search {
  max-width: 400px;
}
.dl-core-navigation_inline .dl-core-navigation__header {
  box-shadow: inset 0 -1px 0 0 var(--g-color-line-generic);
  flex-basis: 56px;
}
.dl-core-navigation_inline .dl-core-navigation__header_with-cloud-tree-select {
  flex-basis: 40px;
}
.dl-core-navigation__header {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  padding: 0 20px 0 12px;
}
.dl-core-navigation .dl-core-navigation-create-dropdown {
  margin-left: auto;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/Navigation/Core/NavigationInline.scss"],"names":[],"mappings":"AAGI;EACI,cAAA;EACA,gBAAA;EACA,aAAA;AAFR;AAIQ;EACI,iBAAA;AAFZ;AAKQ;EACI,gBAAA;AAHZ;AAMQ;EACI,wDAAA;EACA,gBAAA;AAJZ;AAMY;EACI,gBAAA;AAJhB;AASI;EACI,aAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;AAPR;AAUI;EACI,iBAAA;AARR","sourcesContent":[".dl-core-navigation_inline {\n  flex: 1 1 100%;\n  overflow: hidden;\n  display: flex;\n}\n.dl-core-navigation_inline .dl-core-navigation__entries {\n  padding-top: 16px;\n}\n.dl-core-navigation_inline .dl-core-navigation__search {\n  max-width: 400px;\n}\n.dl-core-navigation_inline .dl-core-navigation__header {\n  box-shadow: inset 0 -1px 0 0 var(--g-color-line-generic);\n  flex-basis: 56px;\n}\n.dl-core-navigation_inline .dl-core-navigation__header_with-cloud-tree-select {\n  flex-basis: 40px;\n}\n.dl-core-navigation__header {\n  display: flex;\n  flex: 0 0 auto;\n  align-items: center;\n  padding: 0 20px 0 12px;\n}\n.dl-core-navigation .dl-core-navigation-create-dropdown {\n  margin-left: auto;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
